import script from "./ScoringMapping.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoringMapping.vue?vue&type=script&setup=true&lang=js"

import "./ScoringMapping.vue?vue&type=style&index=0&id=3aed7dee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aed7dee"]])

export default __exports__